import { Link } from 'react-router-dom'
import { User, FileText, ArrowRight, Shield } from 'lucide-react'
import Logo from '../components/Logo'

export default function HomePage() {
  const features = [
    {
      title: '角色卡解析',
      description: '上传 SillyTavern JSON 或 PNG 角色卡，解析并转换为通用 Markdown 系统提示词。支持世界书条目可视化编辑、拖拽排序、实时预览。',
      icon: User,
      path: '/card',
    },
    {
      title: '预设解析',
      description: '上传 SillyTavern 预设 JSON，自由开关、排序、编辑 Prompt 条目，导出为纯文本格式。实时拼接，无需点击生成。',
      icon: FileText,
      path: '/preset',
    },
  ]

  return (
    <div className="max-w-5xl mx-auto px-4 py-12 md:py-16">
      <div className="text-center">
        <div className="mx-auto flex items-center justify-center gap-5">
          <Logo size={56} />
          <h1 className="text-4xl md:text-5xl text-fg font-bold tracking-tight">
            Nova Creator
          </h1>
        </div>

        <p className="mt-4 text-base md:text-lg text-muted leading-relaxed mx-auto max-w-2xl">
          SillyTavern 角色卡与预设的解析转换工具。拖拽、开关、编辑，实时输出干净可用的文本。
        </p>

        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/card" className="ui-btn ui-btn-primary w-full sm:w-auto px-5 py-2.5 rounded-md">
            解析角色卡
            <ArrowRight className="h-4 w-4" />
          </Link>
          <Link to="/preset" className="ui-btn w-full sm:w-auto px-5 py-2.5 rounded-md">
            解析预设
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>

      <div className="mt-10 grid md:grid-cols-2 gap-4 md:gap-6">
        {features.map((feature) => (
          <Link
            key={feature.path}
            to={feature.path}
            className="group ui-card block p-6 md:p-7 transition-colors hover:border-stroke-2"
          >
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-3 min-w-0">
                <div className="h-11 w-11 rounded-lg border border-accent/40 bg-accent-soft flex items-center justify-center group-hover:border-accent/60 transition-colors">
                  <feature.icon className="h-5 w-5 text-accent" />
                </div>
                <h2 className="text-xl md:text-2xl text-fg font-semibold tracking-tight truncate">
                  {feature.title}
                </h2>
              </div>
              <ArrowRight className="w-5 h-5 text-faint group-hover:text-accent group-hover:translate-x-1 transition shrink-0" />
            </div>
            <p className="mt-3 text-muted leading-relaxed">
              {feature.description}
            </p>
          </Link>
        ))}
      </div>

      <div className="mt-12 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-surface border border-stroke text-muted text-sm">
          <Shield size={14} className="text-accent" />
          所有处理均在本地浏览器完成，数据不会上传至服务器
        </div>
      </div>
    </div>
  )
}
